import GroupObject from "../objects/group"
import BaseFixmethod from "@/signomatic/app/fixmethods/base"
import ImageObject from "@/signomatic/app/objects/image"
import RectObject from "@/signomatic/app/objects/rect"

export default class TableStandFixmethod extends BaseFixmethod {
  get externalBottomPadding() {
    return this.height
  }

  get height() {
    return this.state.widthPx / 25.7
  }

  topDrawable() {
    const items = []
    const top = this.state.heightPx
    const width = this.state.widthPx + 25
    const height = this.height
    const img = this.image()

    if (this.imagesLoaded && img) {
      items.push(
        new ImageObject(img, {
          left: 0,
          top,
          scaleX: width / (img.naturalWidth || img.width),
          scaleY: height / (img.naturalHeight || img.height),
        })
      )

      items.push(new RectObject({ fill: "transparent", width, height, left: 0, top: 0 - height }))
    }

    return [new GroupObject(items, { left: 0, top: 0, width, height: height + height * 2 })]
  }

  protected imagePaths() {
    return "/images/signomatic/fix_methods/table_stand.png"
  }
}
